import { render, staticRenderFns } from "./ProjectThumb.vue?vue&type=template&id=a34fb974&scoped=true&"
import script from "./ProjectThumb.vue?vue&type=script&lang=js&"
export * from "./ProjectThumb.vue?vue&type=script&lang=js&"
import style0 from "./ProjectThumb.vue?vue&type=style&index=0&id=a34fb974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34fb974",
  null
  
)

export default component.exports